/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Filters of the validator inbox. Facet keys: tunnels -> tunnelIds, brokers -> brokerIds.
 * 
 * @export
 * @interface ListDemandesValidationFilterDto
 */
export interface ListDemandesValidationFilterDto {
    /**
     * True (default): pending requests addressed to the current validator; false: every answered, cancelled or invalidated one.
     * 
     * @type {boolean}
     * @memberof ListDemandesValidationFilterDto
     */
    toProcess?: boolean;
    /**
     * Filter by tunnels (facet tunnels)
     * @type {Array<string>}
     * @memberof ListDemandesValidationFilterDto
     */
    tunnelIds?: Array<string>;
    /**
     * Filter by brokerage firms (facet brokers)
     * @type {Array<string>}
     * @memberof ListDemandesValidationFilterDto
     */
    brokerIds?: Array<string>;
}

/**
 * Check if a given object implements the ListDemandesValidationFilterDto interface.
 */
export function instanceOfListDemandesValidationFilterDto(value: object): value is ListDemandesValidationFilterDto {
    return true;
}

export function ListDemandesValidationFilterDtoFromJSON(json: any): ListDemandesValidationFilterDto {
    return ListDemandesValidationFilterDtoFromJSONTyped(json, false);
}

export function ListDemandesValidationFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDemandesValidationFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'toProcess': json['toProcess'] == null ? undefined : json['toProcess'],
        'tunnelIds': json['tunnelIds'] == null ? undefined : json['tunnelIds'],
        'brokerIds': json['brokerIds'] == null ? undefined : json['brokerIds'],
    };
}

export function ListDemandesValidationFilterDtoToJSON(json: any): ListDemandesValidationFilterDto {
    return ListDemandesValidationFilterDtoToJSONTyped(json, false);
}

export function ListDemandesValidationFilterDtoToJSONTyped(value?: ListDemandesValidationFilterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'toProcess': value['toProcess'],
        'tunnelIds': value['tunnelIds'],
        'brokerIds': value['brokerIds'],
    };
}

